import React from 'react';
import PropTypes from 'prop-types';
import StoreButtons from './StoreButtons';

// ---------------------------------------------------------------------------
// Inline-markdown renderer.
// Supports __bold__, [text](url), and _italic_ inside paragraphs.
// ---------------------------------------------------------------------------
function renderRichText(text, onCallToAction) {
  const nodes = [];
  let remaining = text;
  let key = 0;

  const pattern = /(__([^_]+(?:_[^_]+)*)__)|(\[([^\]]+)\]\(([^)]+)\)(!)?)|(_([^_]+)_)/;

  while (remaining.length > 0) {
    const match = remaining.match(pattern);
    if (!match) {
      nodes.push(<span key={key += 1}>{remaining}</span>);
      break;
    }
    const before = remaining.slice(0, match.index);
    if (before) {
      nodes.push(<span key={key += 1}>{before}</span>);
    }

    if (match[1]) {
      nodes.push(
        <strong key={key += 1} className="ra-bold">
          {renderRichText(match[2], onCallToAction)}
        </strong>,
      );
    } else if (match[3]) {
      const isCta = Boolean(match[6]);
      const handleClick = isCta ? () => onCallToAction() : undefined;

      nodes.push(
        <a
          key={key += 1}
          href={match[5]}
          target="_blank"
          rel="noopener noreferrer"
          className={`ra-link${isCta ? ' ra-cta' : ''}`}
          onClick={handleClick}
        >
          {match[4]}
        </a>,
      );
    } else if (match[7]) {
      nodes.push(
        // eslint-disable-next-line no-plusplus
        <em key={key++} className="ra-italic">
          {match[8]}
        </em>,
      );
    }

    remaining = remaining.slice(match.index + match[0].length);
  }

  return nodes;
}

function SetupChecklistContentBlock({ block, onCallToAction }) {
  if (typeof block === 'string') {
    return <p className="ra-paragraph">{renderRichText(block, onCallToAction)}</p>;
  }
  if (block && block.type === 'store-buttons') {
    return <StoreButtons />;
  }
  return null;
}

SetupChecklistContentBlock.propTypes = {
  block: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ type: PropTypes.string }),
  ]).isRequired,
  onCallToAction: PropTypes.func,
};

SetupChecklistContentBlock.defaultProps = {
  onCallToAction: undefined,
};

export default function SetupChecklistContent({ blocks, onCallToAction }) {
  return (
    <>
      {blocks.map((block, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <SetupChecklistContentBlock key={idx} block={block} onCallToAction={onCallToAction} />
      ))}
    </>
  );
}

SetupChecklistContent.propTypes = {
  blocks: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ type: PropTypes.string }),
    ]),
  ).isRequired,
  onCallToAction: PropTypes.func,
};

SetupChecklistContent.defaultProps = {
  onCallToAction: undefined,
};
